<template>
  <v-card class="log-card" outlined>
    <v-card-title class="text-subtitle-1 font-weight-bold">MQTT 日志<v-spacer /><v-btn icon small title="清空日志" @click="$emit('clear')"><v-icon small>mdi-delete-outline</v-icon></v-btn></v-card-title>
    <v-card-text class="pa-0">
      <div class="log-console">
        <div v-if="!logs.length" class="grey--text">暂无日志</div>
        <div v-for="(log, index) in logs" :key="index" class="log-line">
          <span class="log-time">{{ log.time }}</span><span :class="`log-${log.type}`">{{ log.type.toUpperCase() }}</span><span>{{ log.message }}</span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default { name: 'MqttLogPanel', props: { logs: { type: Array, required: true } } }
</script>

<style scoped>
.log-card { border-color: #dfe3e8 !important; }
.log-console { background: #172027; color: #d9e2e7; min-height: 130px; max-height: 260px; overflow: auto; padding: 14px; font-family: monospace; font-size: .76rem; }
.log-line { display: flex; gap: 10px; margin-bottom: 5px; word-break: break-word; }
.log-time { color: #90a4ae; flex: 0 0 auto; }
.log-out { color: #81d4fa; }.log-in { color: #a5d6a7; }.log-error { color: #ef9a9a; }.log-system { color: #ffe082; }
</style>
